import { messages } from "@/shared/i18n";

/**
 * Reset Password feature error code mappings
 *
 * Maps backend RFC 7807 Problem Details error codes to localized messages
 */
export const RESET_PASSWORD_ERROR_CODES: Record<string, string> = {
  "Password.Reset": messages.resetPassword.errors.invalidToken,
};
